module.exports = __webpack_public_path__ + "media/images/samples/300x300/13-7ce62618d74eca3d9ad88bf4d9a2d0a2.jpg";